import { render, staticRenderFns } from "./HomonymyList.vue?vue&type=template&id=0b7a4d29&scoped=true&"
import script from "./HomonymyList.vue?vue&type=script&lang=ts&"
export * from "./HomonymyList.vue?vue&type=script&lang=ts&"
import style0 from "./HomonymyList.vue?vue&type=style&index=0&id=0b7a4d29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a4d29",
  null
  
)

export default component.exports